<form *ngIf="datiGeneraliForm && fascicolo && request" [formGroup]="datiGeneraliForm">
  <div class="row">
    <div comboModInput class="col-sm-4" [labelInput]="'Grado'" [location]="'mesi'" formControlName="grado"
    [labelOption]="'descrizione'" [objectReference]="request.fascicolo.grado"
    (onReturn)="onChangeGrado($event)" [optionsCombo]="gradi"></div>

    <div comboModInput [ngClass] ="{'component-suggested': this.autGiudiziariaSuggested &&
    this.autGiudiziariaSuggested.length > 0}"  class="col-sm-4" [labelInput]="'Autorit&agrave; giudiziaria'"
      formControlName="autoritaGiudiziaria" [labelOption]="'descrizione'" [optionsCombo]="autoritaGiudiziarie"
      [mandatory]="true" (change)="loadCittaPerAutoritaGiudiziaria($event)"
      [objectReference]="request.fascicolo.autoritaGiudiziaria" [ngModel]="request.fascicolo.autoritaGiudiziaria"
      [control]="datiGeneraliForm.controls['autoritaGiudiziaria']"
      (onReturn)="request.fascicolo.autoritaGiudiziaria = $event"></div>

    <div comboModInput  [ngClass] ="{'component-suggested': this.sedeSuggested}"  class="col-sm-4" [mandatory]="true" [labelInput]="'Sede autorit&agrave;'"
      formControlName="autoritaGiudiziariaCitta" [optionsCombo]="cittaPerAutoritaGiudiziaria"
      [submitPending]="!request.fascicolo.autoritaGiudiziaria"
      [objectReference]="request.fascicolo.autoritaGiudiziariaCitta"
      [ngModel]="request.fascicolo.autoritaGiudiziariaCitta"
      [control]="datiGeneraliForm.controls['autoritaGiudiziariaCitta']"
      (onReturn)="request.fascicolo.autoritaGiudiziariaCitta = $event"></div>
     <div></div><!--aggiunto div per non ereditare class css non necessaria -->
  </div>
  <div class="row">
    <div textInput [ngStyle]="" [ngClass] ="{'component-suggested': numAndAnnoRuoloSuggested && numAndAnnoRuoloSuggested.length > 0}" [control]="datiGeneraliForm.controls['nruolo']" class="col-sm-3" [labelInput]="'N&deg; ruolo'"
      formControlName="nruolo" [(ngModel)]="request.fascicolo.numeroRuolo"></div>

    <div naturalNumberInput [ngClass] ="{'component-suggested': numAndAnnoRuoloSuggested && numAndAnnoRuoloSuggested.length > 0}" [control]="datiGeneraliForm.controls['annoRuolo']" class="col-sm-3"
      [labelInput]="'Anno ruolo'" [maxLength]="'4'" formControlName="annoRuolo" [checkFormat]="true"
      [(ngModel)]="request.fascicolo.annoRuolo"></div>

    <div textInput [control]="datiGeneraliForm.controls['sezione']" 
      [ngClass] ="{'component-suggested': sectionSuggested && sectionSuggested.length > 0}"
      class="col-sm-3" [labelInput]="'Sezione'"
      formControlName="sezione" [(ngModel)]="request.fascicolo.sezione"></div>

    <div textInput [control]="datiGeneraliForm.controls['giudice']"
      [ngClass] ="{'component-suggested': judgeSuggested && judgeSuggested.length > 0}"
      class="col-sm-3" [labelInput]="'Giudice'"
      formControlName="giudice" [(ngModel)]="request.fascicolo.giudice"></div>
    <div class="col-sm-3" style="margin-top: -15px;"></div>
  </div>
</form>

